export const buildGetAppCatalogConfig = () => ({
    url: '/api/apps',
    method: 'GET',
    baseURL: process.env.PARETO_WORKFLOWS_API_URL,
    params: {
        'filter[integrable]': true,
        perPage: 40,
    },
});
